import { PRINCIPLES, TESTIMONIALS } from "@/mocks/content";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <p className="mb-2 text-sm font-bold tracking-[0.25em] text-primary-600">ABOUT · 关于爆源</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              我们相信，真相藏在来源里
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-700">
              爆源娱乐创立于 2019 年，是一支专注娱乐内容调查的编辑部。我们不追逐下一秒的热搜，而是追问他为什么变成热搜——是哪位知情人士先开了口，哪条狗仔线索提供了画面，哪位记者做了最后的核实。
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              从片场到饭局，从数据后台到法务办公室，我们站在娱乐圈各个工种的交汇处，用「来源优先、证据可溯」的方法论，把碎片拼成可以追问到底的真相。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-4 py-2 text-sm font-medium text-secondary-800">
                <i className="ri-user-heart-line text-secondary-700"></i> 常驻知情线人 37+
              </span>
              <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-4 py-2 text-sm font-medium text-secondary-800">
                <i className="ri-file-search-line text-secondary-700"></i> 累积调查档案 1200+
              </span>
              <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-4 py-2 text-sm font-medium text-primary-700">
                <i className="ri-scales-3-line text-primary-600"></i> 信源分级 · 证据留档
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {PRINCIPLES.map((p) => (
              <div
                key={p.title}
                className="group rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-300 hover:bg-background-50"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-foreground-950 text-lg text-accent-400 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={p.icon}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-black text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* reputation */}
        <div className="mt-16 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          <div className="flex items-center justify-between border-b border-background-200 px-6 py-4 md:px-8">
            <h3 className="font-heading text-lg font-black text-foreground-950 md:text-xl">读者怎么说</h3>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-star-fill"></i> 真实口碑
            </span>
          </div>
          <div className="grid grid-cols-1 divide-y divide-background-200 md:grid-cols-3 md:divide-x md:divide-y-0">
            {TESTIMONIALS.map((t) => (
              <figure key={t.name} className="flex flex-col gap-3 p-6 md:p-7">
                <div className="flex gap-0.5 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="flex-1 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {t.name[0]}
                  </span>
                  <span className="flex flex-col">
                    <span className="text-sm font-semibold text-foreground-950">{t.name}</span>
                    <span className="text-xs text-foreground-500">{t.meta}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}